import * as React from "react";

export const LicenseExpire = (props: { className?: string; size?: number; color: string }): JSX.Element => {
    const iconSize = props.size ?? 24;

    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.68012 7.59438C4.62707 8.94906 4 10.6513 4 12.5C4 16.9183 7.58172 20.5 12 20.5C13.8487 20.5 15.5509 19.8729 16.9056 18.8199L5.68012 7.59438ZM7.09433 6.18016L18.3198 17.4057C19.3729 16.051 20 14.3487 20 12.5C20 8.08172 16.4183 4.5 12 4.5C10.1513 4.5 8.44902 5.12709 7.09433 6.18016ZM19.0721 19.57C20.8811 17.7605 22 15.2609 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5C14.762 22.5 17.2624 21.3803 19.0721 19.57Z"
                fill={props.color}
            />
        </svg>
    );
};
